import React, { Component, Fragment } from 'react'
import { Breadcrumb, Button, Card, Popconfirm, Row, Steps, Tooltip } from 'antd'
import Overview from '../Form/Overview'
import KeyTerms from '../Form/KeyTerms'
import Payment from '../Form/Payment'
import Communication from '../Form/Communication'
import style from './style.css'
import Rates from '../Form/Rates'

const Step = Steps.Step

class AddContract extends Component {
  render() {
    const titles = {
      new: 'Create New Vendor Account',
      update: 'Update Vendor Account',
    }
    const descriptions = {
      new: 'You can add new Vendor Account by following the steps below.',
      update: 'You need to follow the steps below to update Vendor Account.',
    }
    const {
      member,
      supplier,
      memberFetching,
      submitting,
      contract,
      current,
      showSkip,
      submit,
      update,
      updateContract,
      communicationCmpRef,
      key,
      type,
      prev,
      next,
      skip,
      overviewCmpRef,
      keyTermsCmpRef,
      payrollCmpRef,
      ratesCmpRef,
      // onChangeCompany,
    } = this.props

    const submitButton = {
      new: (
        <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
          <Button loading={submitting} type="primary">
            Submit
          </Button>
        </Popconfirm>
      ),
      update: (
        <Popconfirm title="Sure to Update?" onConfirm={() => update()}>
          <Button loading={submitting} type="primary">
            Update
          </Button>
        </Popconfirm>
      ),
    }
    // const steps = [
    //   {
    //     title: 'Contract Overview',
    //     content: (
    //       <Overview
    //         supplier={supplier}
    //         ref={child => {
    //           this.overviewCmp = child
    //         }}
    //         contract={this.state.contract}
    //       />
    //     ),
    //     key: 'overview',
    //   },
    //   {
    //     title: 'Key Terms',
    //     content: (
    //       <KeyTerms
    //         supplier={supplier}
    //         ref={child => {
    //           this.keyTermsCmp = child
    //         }}
    //         updateContract={this.updateContract}
    //         contract={this.state.contract}
    //       />
    //     ),
    //     key: 'keyTerms',
    //   },
    //   {
    //     title: 'Payment',
    //     content: (
    //       <Payment
    //         updateContract={this.updateContract}
    //         supplier={supplier}
    //         ref={child => {
    //           this.payrollCmp = child
    //         }}
    //         contract={this.state.contract}
    //       />
    //     ),
    //     key: 'payroll',
    //   },
    //   {
    //     title: 'Communication',
    //     content: (
    //       <Communication
    //         updateContract={this.updateContract}
    //         supplier={supplier}
    //         member={member}
    //         loading={memberFetching}
    //         ref={child => {
    //           this.communicationCmp = child
    //         }}
    //         contract={this.state.contract}
    //       />
    //     ),
    //     key: 'communication',
    //   },
    //   {
    //     title: 'Lines',
    //     content: (
    //       <Lines
    //         updateContract={this.updateContract}
    //         supplier={supplier}
    //         ref={child => {
    //           this.linesCmp = child
    //         }}
    //         type={type}
    //         contract={this.state.contract}
    //       />
    //     ),
    //     key: 'lines',
    //   },
    // ]
    let steps = [
      {
        title: 'Account Overview',
        content: (
          <Overview {...this.props} supplier={supplier} contract={contract} ref={overviewCmpRef} />
        ),
        key: 'overview',
      },
      {
        title: 'Key Terms',
        content: (
          <KeyTerms
            supplier={supplier}
            updateContract={updateContract}
            ref={keyTermsCmpRef}
            contract={contract}
          />
        ),
        key: 'keyTerms',
      },
      {
        title: 'Billing & Payment',
        content: (
          <Payment
            updateContract={updateContract}
            supplier={supplier}
            contract={contract}
            ref={payrollCmpRef}
          />
        ),
        key: 'payroll',
      },
      {
        title: 'Communication',
        content: (
          <Communication
            updateContract={updateContract}
            supplier={supplier}
            member={member}
            type={type}
            ref={communicationCmpRef}
            contract={contract}
          />
        ),
        key: 'communication',
      },
      {
        title: 'Rates',
        content: (
          <Rates
            updateContract={updateContract}
            supplier={supplier}
            type={type}
            ref={ratesCmpRef}
            contract={contract}
          />
        ),
        key: 'rates',
      },
    ]

    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Purchase</Breadcrumb.Item>
              <Breadcrumb.Item href="#/purchasing/suppliers/list">Vendors List</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/purchasing/suppliers/${member._key}/`}>
                {member.fn}
              </Breadcrumb.Item>
              {type === 'update' && (
                <Breadcrumb.Item
                  href={`#/purchasing/suppliers/${key}/contracts/${contract._key}/view`}>
                  {contract.code}
                </Breadcrumb.Item>
              )}
            </Breadcrumb>
            <h2 className={style.title}>{titles[type]}</h2>
            <p className={style.paragraph}>{descriptions[type]}</p>
          </Row>
        </Card>
        <Card loading={memberFetching} className={style.contentCard}>
          <Steps current={current}>
            {steps.map(item => (
              <Step key={item.key} title={item.title} />
            ))}
          </Steps>
          <div style={{ marginTop: '50px', marginBottom: '10px' }} className="steps-content">
            {steps[current].content}
          </div>
          <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
            {current > 0 && (
              <Button style={{ marginRight: 8 }} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button style={{ width: '100px' }} type="primary" onClick={() => next()}>
                Next
              </Button>
            )}
            {current < steps.length - 1 && showSkip && (
              <Tooltip title="Skip validation for now">
                <Button
                  icon="double-right"
                  shape="dashed"
                  style={{ marginLeft: 10 }}
                  onClick={() => skip()}
                />
              </Tooltip>
            )}
            {current === steps.length - 1 &&
              (submitButton[type] || (
                <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
                  <Button loading={submitting} type="primary">
                    Submit
                  </Button>
                </Popconfirm>
              ))}
          </div>
        </Card>
      </Fragment>
    )
  }
}

export default AddContract
